import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const leaveRequestApi = createApi({
  reducerPath: 'leaveRequestApi',
  baseQuery: rtkBaseQuery('/staff/LeaveRequest'),
  providesTags: ['LeaveRequests'],
  endpoints: (builder) => ({
    checkForRequest: builder.query({
      query: () => '/CheckForRequest',
    }),
    addLeaveRequestStatus: builder.mutation({
      query: (params) => ({
        url: '/AddLeaveRequestStatus',
        method: 'POST',
        params,
      }),
    }),
    editLeaveRequestStatus: builder.mutation({
      query: (params) => ({
        url: '/EditLeaveRequestStatus',
        method: 'PUT',
        params,
      }),
    }),
    getLeaveRequestStatus: builder.query({
      query: ({ id, lang }) => `/GetLeaveRequestStatus?id=${id}&lang=${lang}`,
    }),
    getAllLeaveRequestStatus: builder.query({
      query: ({ lang }) => `/GetAllLeaveRequestStatus?lang=${lang}`,
    }),
    deleteLeaveRequestStatus: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/DeleteLeaveRequestStatus?id=${id}`,
        method: 'DELETE',
        body,
      }),
    }),
    addLeaveCategory: builder.mutation({
      query: (params) => ({
        url: '/AddLeaveCategory',
        method: 'POST',
        params,
      }),
    }),
    editLeaveCategory: builder.mutation({
      query: (params) => ({
        url: '/EditLeaveCategory',
        method: 'PUT',
        params,
      }),
    }),
    getLeaveCategory: builder.query({
      query: ({ id, lang }) => `/GetLeaveCategory?id=${id}&lang=${lang}`,
    }),
    getAllLeaveCategory: builder.query({
      query: ({ lang }) => `/GetAllLeaveCategory?lang=${lang}`,
    }),
    deleteLeaveCategory: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/DeleteLeaveCategory?id=${id}`,
        method: 'DELETE',
        body,
      }),
    }),
    addLeaveSubCategory: builder.mutation({
      query: (params) => ({
        url: '/AddLeaveSubCategory',
        method: 'POST',
        params,
      }),
    }),
    editLeaveSubCategory: builder.mutation({
      query: (params) => ({
        url: '/EditLeaveSubCategory',
        method: 'PUT',
        params,
      }),
    }),
    getLeaveSubCategory: builder.query({
      query: ({ id, lang }) => `/GetLeaveSubCategory?Id=${id}&lang=${lang}`,
    }),
    getAllLeaveSubCategory: builder.query({
      query: ({ lang }) => `/GetAllLeaveSubCategory?lang=${lang}`,
    }),
    getAllLeaveSubCategoryByCategoryId: builder.query({
      query: ({ CategoryId, lang }) =>
        `/GetAllLeaveSubCategoryByCategoryId?CategoryId=${CategoryId}&lang=${lang}`,
    }),
    getAllSenderLeaveRequest: builder.query({
      query: (params) => ({
        url: '/GetAllSenderLeaveRequest',
        method: 'GET',
        params,
      }),
      providesTags: ['LeaveRequests'],
    }),
    getAllApproverLeaveRequest: builder.query({
      query: (params) => ({
        url: '/GetAllApproverLeaveRequest',
        method: 'GET',
        params,
      }),
      keepUnusedDataFor: 1,
    }),
    addLeaveRequest: builder.mutation({
      query: (body) => ({
        url: '/AddLeaveRequest',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LeaveRequests'],
    }),
    addLeaveSubordinateRequest: builder.mutation({
      query: (body) => ({
        url: '/AddLeaveRequestForSubordinate',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LeaveRequests'],
    }),
    editLeaveRequest: builder.mutation({
      query: (params) => ({
        url: '/EditLeaveRequest',
        method: 'PUT',
        params,
      }),
    }),
    getDepartmentHeads: builder.query({
      query: () => '/GetDepartmentHeads',
    }),
    getSubordinateEmployees: builder.query({
      query: (params) => ({
        url: '/GetSubordinate',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useCheckForRequestQuery,
  useAddLeaveRequestStatusMutation,
  useEditLeaveRequestStatusMutation,
  useGetLeaveRequestStatusQuery,
  useGetAllLeaveRequestStatusQuery,
  useDeleteLeaveRequestStatusMutation,
  useAddLeaveCategoryMutation,
  useEditLeaveCategoryMutation,
  useGetLeaveCategoryQuery,
  useGetAllLeaveCategoryQuery,
  useDeleteLeaveCategoryMutation,
  useAddLeaveSubCategoryMutation,
  useEditLeaveSubCategoryMutation,
  useGetLeaveSubCategoryQuery,
  useGetAllLeaveSubCategoryQuery,
  useGetAllLeaveSubCategoryByCategoryIdQuery,
  useGetAllSenderLeaveRequestQuery,
  useGetAllApproverLeaveRequestQuery,
  useAddLeaveRequestMutation,
  useEditLeaveRequestMutation,
  useGetDepartmentHeadsQuery,
  useGetSubordinateEmployeesQuery,
  useAddLeaveSubordinateRequestMutation,
} = leaveRequestApi;
